<template>
  <div
      @mouseenter="hover = true"
      @mouseleave="hover = false"
      @click="$emit('click')"
      :class="cardClasses"
  >
    <div class="tw-flex tw-items-center tw-justify-center tw-text-base">
      <p><i class="fa fa-plus"></i> {{ text }}</p>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from 'vue';

export default defineComponent({
  name: 'AddElementCard',

  emits: ['click'],

  props: {
    text: {
      type: String,
      required: true,
    },
    fullHeight: {
      type: Boolean,
      default: false,
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    const hover = ref(false);

    const cardClasses = computed(() => [
      'tw-border-2 tw-border-dashed tw-rounded-lg tw-cursor-pointer',
      'tw-flex tw-items-center tw-justify-center',
      'tw-transition-colors',
      'tw-border-secondary-grey tw-text-secondary-grey',
      props.fullHeight ? 'tw-h-full' : 'tw-h-auto',
      props.fullWidth ? 'tw-w-full' : 'tw-w-auto',
    ]);

    return {
      hover,
      cardClasses,
    };
  },
});
</script>
